export const SOFTPHONE_OPEN_EVENT = "farktor:softphone-open";
export const SOFTPHONE_DIAL_EVENT = "farktor:softphone-dial";
export const SOFTPHONE_INCOMING_EVENT = "farktor:softphone-incoming";
export const SOFTPHONE_WORKFLOW_EVENT = "farktor:softphone-workflow";
export const SOFTPHONE_WORKFLOW_RESULT_EVENT = "farktor:softphone-workflow-result";
